import React, { useEffect, memo } from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { useQuery } from 'react-apollo-hooks'
import { useTranslation } from 'react-i18next'

import './styles.css'
import { Tour } from './components'
import { TourQuery, ITourQueryVariables, ITourQueryData, EAppActionTypes, withAppStoreValue, AppStoreDispatchAction } from '../../store'
import { MainLayout, TourNearByNav, Loading } from '../../components'

interface IComponentCoreAppStoreProps {
    dispatch: AppStoreDispatchAction
}

const ComponentCore = memo((props: RouteComponentProps & IComponentCoreAppStoreProps) => {
    const { location: { state: { tourId = undefined } = {}}, dispatch } = props
    if (!tourId) return <Redirect to="/" />

    const { i18n: { languages: [language] }} = useTranslation();
    const { data, loading } = useQuery<any, ITourQueryVariables, any>(TourQuery, { 
        variables: {
            where: {
                language,
                id: tourId
            }
        }
    });

    const tour = data && (data as ITourQueryData).tour;

    useEffect(() => {
        if (tour) {
            dispatch({ type: EAppActionTypes.SetTour, tour })
        }
    }, [tour])

    if (!tour || loading ) {
        return (
            <Loading />
        )
    }

    return (
        <MainLayout
            pageHeader={<TourNearByNav tour={tour}/>}
            pageContent={<Tour tour={tour} language={language}/>}
            scrollBarExtraClassName={'tour-scroll-wrapper'}
        />
    )
})

export default withAppStoreValue<IComponentCoreAppStoreProps, RouteComponentProps>(ComponentCore, ['dispatch'])

interface IResetAppTourProps {
    dispatch: AppStoreDispatchAction
}

const ResetAppTourCore = memo(({ dispatch} : IResetAppTourProps) => {
    useEffect(() => {
        dispatch({ type: EAppActionTypes.SetTour, tour: null })
    }, [])
    return null
})

export const ResetAppTour = withAppStoreValue<IResetAppTourProps>(ResetAppTourCore, ['dispatch'])